// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__F5VeK","label":"Category_label__2XxpZ","content":"Category_content__3ofkT","header":"Category_header__fF6Gq","location":"Category_location__38YTU"};